import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
//import domGeom = require("dojo/dom-geometry");
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PepRosterTable.html?raw';

import topic from 'dojo/topic';


import PepEmploymentWidget from '../PEP/Employment/PepEmployment';

import _tmplYElement from './Templates/yAxisElement.html?raw';
import _tmplDayInfo from './Templates/employmentDayRecord.html?raw';
import _tmplWeekRecordInfo from './Templates/weekRecordInfo.html?raw';

import PepEmployment from '../PEP/Employment/PepEmployment';
import PepHome from './PepRosterStart';
import PepEmploymentEditor from './Employment/PepEmploymentEditor';
import PepXelement from '../PEP/Axis/PepXelement';
import PepCellInfoForm from './CellInfo/PepCellInfoForm';
import { EntityHelpers, FeatureHelpers, StringHelpers, ToasterHelpers, TranslationHelpers } from "../../more/Helpers";
import PEPcellNotesData from './CellInfo/PepCellNotesData';
import domConstruct from 'dojo/dom-construct';
import { PEP } from "./PepTypes";
//import PepEmployment = require("../PEP/Employment/PepEmployment");


interface partialUpdatesRequest extends PEP.Coordinates {

    //itemsY: string[],
    updateCellContent: boolean,
    updateXAxisDescriptor: boolean,
    updateYAxisDescriptor: boolean

}
class PepRosterTable extends compose(_WidgetBaseSP) {
    templateString: any = template;

    resultMessageErrorContainer: HTMLElement;
    resultMessageError: HTMLElement;
    tableContainer: HTMLDivElement;
    table: HTMLTableElement;
    yContainer: HTMLDivElement;
    xContainer: HTMLDivElement;
    yContainerInfoA: HTMLDivElement;
    yContainerInfoB: HTMLDivElement;
    stickyHeader: HTMLDivElement;
    stickyNavigationContainer: HTMLDivElement;
    infoSpacingA: HTMLDivElement;
    infoSpacingB: HTMLDivElement;

    calendarWeekNavigationContainer: HTMLDivElement;
    btnCalendarWeekNavigation: HTMLButtonElement;


    private _requestTimeout: number;
    private _initialised: boolean = false;
    //private _lastResponse: PEP.DataGrid;
    private _isSwitchingXActive: boolean = false;

    private _table: HTMLTableElement = null;
    PepHome: MdsLax<InstanceType<typeof PepHome>> = null;

    private _xDescriptors: Array<PEP.XAxisDescriptor>;
    private _yDescriptors: Array<PEP.YRowContract>;
    private _employmentWidgets: Array<MdsLax<InstanceType<typeof PepEmploymentWidget>>>;
    // _employmentWidgetDict: Record<string, PepEmploymentWidget>;

    private cells: Array<PEP.Cell>;
    private cellDict: Record<string, PEP.Cell>;
    private columns: Array<PEP.XCol>;
    private rows: Array<PEP.YRow>;
    private weekRecordElementsA: Array<PEP.WeekRecordElement>;
    private weekRecordElementsB: Array<PEP.WeekRecordElement>;

    private windowEx: PEP.WindowEx;

    private submitQueue: Array<MdsLax<InstanceType<typeof PepEmploymentWidget>>>;
    private _submitQueueTimeout: number = null;
    isDirty: boolean = false;

    // aktuelle Einstellungen
    private _currentAxisSettings: PEP.AxisConfig = {
        offset: 0, // 0 Tage ab base verschoben
        colCount: 7,
        base: null,
        yIDs: [],
        xIDs: [],
        stepNext: 7,
        stepPrevious: -7,        
    };


    showError(message: string | false) {
        if (message === false) {
            this.UiModder.domClass.add(this.resultMessageErrorContainer, "w3-hide");
        } else {
            this.UiModder.domAttr.set(this.resultMessageError, "innerHTML", message);
            this.UiModder.domClass.remove(this.resultMessageErrorContainer, "w3-hide");

        }
    }

    private updateXDescriptors(xDescriptorUpdates: Array<PEP.XAxisDescriptor>) {
        if (!xDescriptorUpdates?.length) return;
        for (let update of xDescriptorUpdates) {
            for (let col of this.columns) {
                if (col.ID == update.ID) {
                    let xElement = col.headerNode as MdsLax<InstanceType<typeof PepXelement>>;
                    xElement.setData(update);
                    break;
                }
            }
        }
    }

    setWeekRecordAxisData(weekRecord: PEP.WeekInfoDataset, bRebuild?: boolean): void {

        if (bRebuild === true) {
            this.destroyWeekRecordInfo();
        }

        if (!weekRecord)

        this.infoSpacingA.innerHTML = weekRecord.labelA;
        this.infoSpacingB.innerHTML = weekRecord.labelB;

        
        for (let i = 2; i <= 2; i++) { // Hinweis: Spalte A derzeit nicht in Verwendung, daher Start mit 2

            let sourceObject = weekRecord.weekRecordDataA;
            let targetContainer = this.yContainerInfoA;
            let existingList = this.weekRecordElementsA;

            
            if (i == 2) {
                sourceObject = weekRecord.weekRecordDataB;
                targetContainer = this.yContainerInfoB;
                existingList = this.weekRecordElementsB;
            }
            let targetList = [];

            //console.debug("setWeekRecordAxisData existingList", existingList, this.weekRecordElementsB);
            
            for (let entry of sourceObject?.entries) {

                let infoContainer: HTMLElement = null;;
                if (bRebuild !== true) {
                    for (let existingElement of existingList) {

                        

                        if (existingElement.data.yID == entry.yID) {
                            infoContainer = existingElement.node;
                            break;
                        }
                    }
                }

                //console.debug("setWeekRecordAxisData search for existing container", infoContainer, entry);

                if (infoContainer == null && bRebuild === true) {
                    infoContainer = this.UiModder.domConstruct.create("div",
                        {
                            // innerhtml wird unten zusammengestellt
                            "className": "flex_row_stretch PEP_weekRecordContainer"
                        },
                        targetContainer
                    );
                } else if (infoContainer != null) {
                    this.UiModder.domConstruct.empty(infoContainer);
                }

                if (infoContainer != null) {
                    // für jede Spalte aus der maximalen Spaltenanzahl einen Container erzeugen
                    let htmlArray: Array<string> = [];
                    for (let x = 0; x < sourceObject.columnCount; x++) {
                        htmlArray.push("");
                    }

                    for (let dataLine of entry.lines) {
                        let weekRecordHTML = this.stringFormat(_tmplWeekRecordInfo,
                            dataLine.label,
                            dataLine.value,
                            dataLine.colorationBG != "" ? dataLine.colorationBG : "none",
                            dataLine.colorationTXT != "" ? dataLine.colorationTXT : "none",
                            dataLine.tooltip
                        );

                        htmlArray[dataLine.targetColumn - 1] += weekRecordHTML;
                    }

                    // jetzt die Datenzeilen in ihre Spalten schreiben
                    for (let y = 0; y < htmlArray.length; y++) {
                        this.UiModder.domConstruct.create("div",
                            {
                                "className": "PEP_weekRecordColumn",
                                "innerHTML": htmlArray[y]
                            },
                            infoContainer
                        );
                    }

                    let infoElement: PEP.WeekRecordElement = {
                        data: entry,
                        node: infoContainer
                    };

                    if (bRebuild === true) {
                        if (i == 1) {
                            this.weekRecordElementsA.push(infoElement);
                        }
                        else if (i == 2) {
                            this.weekRecordElementsB.push(infoElement);
                        }
                    }
                }
            }

            
        }
        //console.debug("setWeekRecordAxisData", weekRecord, this.weekRecordElementsA, this.weekRecordElementsB);
        this.recalcColumnWidths();

        this.UiModder.domClass.remove(this.yContainerInfoA, "obsolete");
        this.UiModder.domClass.remove(this.yContainerInfoB, "obsolete");
        this.UiModder.domClass.remove(this.infoSpacingA, "obsolete");
        this.UiModder.domClass.remove(this.infoSpacingB, "obsolete");
    }

    setAxisData(xData: Array<PEP.XAxisDescriptor>, yData?: Array<PEP.YRowContract>, newBase?: any): void {

        let bRedrawX = xData != null;
        let bRedrawY = this._initialised == false;// todo: || this._yData.length != yData.length;

        //console.debug("setAxisData", xData, yData, newBase);

        if (xData != null) {
            this._xDescriptors = xData;
        }

        if (typeof (yData) != "undefined" && yData != null) {
            this._yDescriptors = yData;
        }

        this.redrawNakedTable(bRedrawX, bRedrawY);

        if (this._initialised !== true) {
            this.setNewStart(0, false, newBase, true);
        }
    }

    private closeCalendarWeekNavigation(): void {
        if (this._destroyed == true) return;

        this.UiModder.domClass.remove(this.btnCalendarWeekNavigation, "hover");
        this.UiModder.domClass.add(this.calendarWeekNavigationContainer, "w3-hide");
    }

    private showCalendarWeekNavigation(): void {
        this.UiModder.domClass.add(this.btnCalendarWeekNavigation, "hover");
        this.UiModder.domClass.remove(this.calendarWeekNavigationContainer, "w3-hide");

        this._currentSelectCalendarWeekNavigation.scrollIntoView({ behavior: "auto", block: "center" });
    }

    private toggleCalendarWeekNavigation(targetState?: boolean) {
        if (targetState !== true && targetState !== false) {
            if (this.UiModder.domClass.contains(this.calendarWeekNavigationContainer, "w3-hide")) {
                targetState = true;
            } else {
                targetState = false;
            }
        }

        if (targetState == false) {
            this.closeCalendarWeekNavigation();
        } else {
            this.showCalendarWeekNavigation();
        }
    }

    private _currentSelectCalendarWeekNavigation: HTMLElement = null;
    drawCalendarWeekNavigation(data: Array<PEP.CalendarWeekNavigation>) {
        this.UiModder.domConstruct.empty(this.calendarWeekNavigationContainer);

        //console.debug("drawCalendarWeekNavigation", this._currentXAxisDisplaySettings, data);
        let useUrlParams = FeatureHelpers.hasFeature("PEP/useUrlParams");

        for (let week of data) {

            let navEntry = this.UiModder.domConstruct.create("div",
                {
                    "className": "paddingSmall nav"
                }, this.calendarWeekNavigationContainer);

            if (week.currentWeek === true) this.UiModder.domClass.add(navEntry, "current");

            if (week.base == this._currentAxisSettings.base) {
                this.UiModder.domClass.add(navEntry, "selected");
                this._currentSelectCalendarWeekNavigation = navEntry;

                useUrlParams == true ? this.setUrlParameter(PEP.UrlParameter.calendarWeek, week.ID) : null;

            } else {
                on(navEntry, "click", lang.hitch(this, this._onClick_CalendarWeek, 0, week.base))
                this.UiModder.domClass.add(navEntry, "hoverDark");
            }

            let mainLabel = this.UiModder.domConstruct.create("span",
                {
                    "className": "mainLabel",
                    "innerHTML": week.mainLabel
                }, navEntry);

            let secondaryLabel = this.UiModder.domConstruct.create("span",
                {
                    "className": "secondaryLabel",
                    "innerHTML": week.secondaryLabel
                }, navEntry);
        }

    }

    //private addDays(date: Date, nDays: number): Date {

    //    if (date == null) {
    //        return null;
    //    }

    //    let newDate: Date = new Date(date.getTime() + nDays * 24 * 60 * 60 * 1000);

    //    return newDate;
    //}

    private destroyTable(bResetX?: boolean, bResetY?: boolean): void {
        

        if (bResetX === true) {
            this.UiModder.domConstruct.empty(this.xContainer);
            this.columns = [];
        } else {
            for (let column of this.columns) {
                column.cells = [];
            }
        }

        for (let empl of this._employmentWidgets) {
            this.UiModder.domClass.add(empl.domNode, "w3-hide");
            setTimeout(lang.hitch(empl, "destroy"), 222);
            //empl.destroy();
        }

        this._employmentWidgets = [];
        //this._employmentWidgetDict = {};

        if (bResetY === true) {
            this.UiModder.domConstruct.empty(this.yContainer);
            this.rows = [];
        } else {
            for (let row of this.rows) {
                row.cells = [];
            }
        }
        
        this.UiModder.domConstruct.empty(this.table);
        this.cells = [];
        this.cellDict = {};
        
    }

    private _onClick_xElementHeader(ID: string, evt: MouseEvent) {
        evt.stopPropagation();

        let node = document.getElementById("specialNotes-" + ID);

        if (node == null) return;

        this.UiModder.domClass.toggle(node, "hover");

    }

    private redrawNakedTable(bRedrawXHead?: boolean, bRedrawYEntries?: boolean): void {
        this.destroyTable(bRedrawXHead === true, bRedrawYEntries === true);

        //console.debug("redrawTable - X Y", bRedrawXHead, bRedrawYEntries, this._xDescriptors, this._yDescriptors);

        this.UiModder.domClass.remove(this.yContainerInfoA, "obsolete");
        this.UiModder.domClass.remove(this.yContainerInfoB, "obsolete");
        this.UiModder.domClass.remove(this.infoSpacingA, "obsolete");
        this.UiModder.domClass.remove(this.infoSpacingB, "obsolete");
        this.UiModder.domClass.remove(this.xContainer, "obsolete");
        this.UiModder.domClass.remove(this.table, "obsolete");

        if (bRedrawXHead === true) {
            this._currentAxisSettings.xIDs = [];

            for (let xEntity of this._xDescriptors) {
                let xElement: MdsLax<InstanceType<typeof PepXelement>> = new PepXelement();
                //console.debug("redrawNakedTable xEntities", xEntity, xElement);
                this.UiModder.domConstruct.place(xElement.domNode, this.xContainer);

                xElement.setData(xEntity);

                let xEntry: PEP.XCol = { cells: [], descriptor: xEntity, headerNode: xElement, ID: xEntity.ID };
                this.columns.push(xEntry);
                
                this._currentAxisSettings.xIDs.push(xEntity.ID);

                on(xElement, "update", lang.hitch(this, this._onUpdateXelement, xEntry));
            }
        }

        if (bRedrawYEntries === true) {
            this._currentAxisSettings.yIDs = [];
            for (let yEntity of this._yDescriptors) {

                let yElement: HTMLDivElement = <HTMLDivElement>this.UiModder.domConstruct.create("div",
                    { "className": "PEP_yElement PEP_coloredElement" },
                    this.yContainer);

                let locked: boolean = yEntity.locked === true;

                if (locked) {
                    this.UiModder.domClass.add(yElement, "locked");
                } else {
                    this.UiModder.domClass.remove(yElement, "locked");
                }

                if (FeatureHelpers.hasFeature("PEP/ClickableContract")) {
                    this.UiModder.domClass.add(yElement, "clickable");
                    on(yElement, "click", lang.hitch(this, this._onClick_Contract, yEntity));
                }


                // Labels setzen!
                let smallInfoTxt = StringHelpers.stringReplaceAll(yEntity.description, "\n", "<br>");
                if (!smallInfoTxt) smallInfoTxt = "";
                this.UiModder.domAttr.set(yElement, "innerHTML", this.stringFormat(_tmplYElement,
                    StringHelpers.stringReplaceAll(yEntity.label, "\n", "<br>"),
                    smallInfoTxt)
                );

                //this.UiModder.domStyle.set(yElement, "backgroundColor", yEntity.coloration);
                //this.UiModder.domStyle.set(yElement, "color", yEntity.colorationTXT);

                yElement.style.setProperty("--colorBG", yEntity.coloration);
                yElement.style.setProperty("--colorTXT", yEntity.colorationTXT);


                let yEntry: PEP.YRow = {
                    cells: [],
                    descriptor: yEntity,
                    ID: yEntity.ID,
                    headerNode: yElement,
                    node: null,
                    inactive: false
                };
                this.rows.push(yEntry);

                this._currentAxisSettings.yIDs.push(yEntity.ID);
            }
        }

        let locks: Array<PEP.CellLock> = [];

        for (let row of this.rows) {

            let tableRow = <HTMLTableRowElement>this.UiModder.domConstruct.create("tr",
                { "className": "PEP_tableRow" },
                this.table);

            row.node = tableRow;

            for (let column of this.columns) {
                let tableCell: HTMLTableCellElement = <HTMLTableCellElement>this.UiModder.domConstruct.create("td",
                    { "className": "PEP_tableCell" },
                    tableRow);  

                let cellContainer: HTMLDivElement = <HTMLDivElement>this.UiModder.domConstruct.create("div",
                    { "className": "PEP_cellContainer" },
                    tableCell); 

                let employmentsContainer: HTMLDivElement = <HTMLDivElement>this.UiModder.domConstruct.create("div",
                    { "className": "PEP_employmentContainer emptyCreateClick" },
                    cellContainer); 

                let infoContainer: HTMLDivElement = <HTMLDivElement>this.UiModder.domConstruct.create("div",
                    { "className": "PEP_cellInfoContainer" },
                    cellContainer, "last"); 

                //row.descriptor.
                let bLock = row.descriptor.locked === true || column.descriptor.locked === true;

                // prüfen ob an diesem Wochentag erlaubt laut Vertrag
                if (column.descriptor.date && bLock != true && !!row.descriptor) {
                    let columnDate: Date = null;
                    if (typeof (column.descriptor.date) == "string") {
                        columnDate = new Date(column.descriptor.date);
                    } else if (column.descriptor.date.valueOf) {
                        columnDate = new Date(column.descriptor.date.valueOf());
                    }

                    let weekday = columnDate.getDay();

                    switch (weekday) {
                        case 0:
                            if (row.descriptor.bSunday === false) bLock = true;
                            break;

                        case 1:
                            if (row.descriptor.bMonday === false) bLock = true;
                            break;

                        case 2:
                            if (row.descriptor.bTuesday === false) bLock = true;
                            break;

                        case 3:
                            if (row.descriptor.bWednesday === false) bLock = true;
                            break;

                        case 4:
                            if (row.descriptor.bThursday === false) bLock = true;
                            break;

                        case 5:
                            if (row.descriptor.bFriday === false) bLock = true;
                            break;

                        case 6:
                            if (row.descriptor.bSaturday === false) bLock = true;
                            break;

                        default:
                            
                            break;
                    }

                    
                }

                let PepCell: PEP.Cell = {
                    table: this,
                    node: cellContainer,
                    tableCellNode: tableCell,
                    employmentsNode: employmentsContainer,
                    employmentData: [],
                    infoData: null,
                    dirtyCount: 0,
                    xID: column.ID,
                    yID: row.ID,
                    column: column,
                    row: row,
                    locked: bLock,
                    employmentWidgets: [],
                    clickEvent: null,
                    infoNode: infoContainer,
                    dayRecordNode: null
                };
                row.cells.push(PepCell);
                column.cells.push(PepCell);
                this.cells.push(PepCell);
                this.cellDict[column.ID + row.ID] = PepCell;

                // manche Zellen sind schon von Haus aus gesperrt. falls eine solche Info vorhanden ist, dann hinterher schon mal mit applyLocks einfügen
                if (PepCell.locked === true) {
                    locks.push({
                        xID: column.ID,
                        yID: row.ID,
                        locked: true
                    });
                }

                on(infoContainer, "click", lang.hitch(this, this._onClick_CellInfoContainer, PepCell));

                //// leeres Employment zum Neuerzeugen
                //let blankEmployment: PepEmployment = new PepEmploymentWidget();
                //this.UiModder.domConstruct.place(blankEmployment.domNode, PEP.PepCell.node);
                //blankEmployment.tableCell = PEP.PepCell;

                //blankEmployment.startup();

                //PEP.PepCell.employments.push(blankEmployment);
            }
        }

        if (locks.length) {
            this.applyLocks(locks);
        }

    }

    private loadDataDelayed(bReloadXAxis?: boolean): void {
        if (this._requestTimeout != null) {
            clearTimeout(this._requestTimeout);
            this._requestTimeout = null;
        }

        this._requestTimeout = setTimeout(lang.hitch(this, this.loadData, bReloadXAxis), 600);
    }

    private loadData(bReloadXAxis?: boolean): void {
        if (this._requestTimeout != null) {
            clearTimeout(this._requestTimeout);
            this._requestTimeout = null;
        }
        this._isSwitchingXActive = true;
        this.UiModder.domClass.add(this.stickyNavigationContainer, "inactive");
        //this.UiModder.domClass.add(this.tableContainer, "hide");
        this._initialised = true;

        
        // aktuell eingestellte Ansicht ans Backend, neue Daten erhalten

        console.log("table loadData", bReloadXAxis, this._currentAxisSettings);

        this.StandbyStart(this.tableContainer);

        if (bReloadXAxis === true) {

            let contractIDs: Array<string> = [];
            for (let yDesc of this._yDescriptors) {
                contractIDs.push(yDesc.ID);
            }

            var url = window.appRoot + "Pep/GetXAxisDescriptors";

            var data = {
                "offset": this._currentAxisSettings.offset,
                "stepCount": this._currentAxisSettings.colCount,
                displaySettings: this.windowEx.DisplaySettings,
                "base": this._currentAxisSettings.base,
                "contractIDs": contractIDs // brauchma für die Wochensummen 
            };
            var stringData = JSON.stringify(data);

            this.RequestManager.post(
                url,
                {
                    jsonData: stringData,
                    xAxisOnly: true
                },
                lang.hitch(this, this._onGetXAxisDescriptorsResult),
                lang.hitch(this, this._onGetXAxisDescriptorsError),
                false // sync
            );
        } else {
            this._loadDataGrid();
        }
    }
    private _onGetXAxisDescriptorsResult(response: PEP.AxisResponse) {

        console.log("_onGetXAxisDescriptorsResult", response);

        this.showError(false);

        if (response.base) {
            this._currentAxisSettings.base = response.base;
            this._currentAxisSettings.offset = 0;
            this._currentAxisSettings.stepNext = this._currentAxisSettings.colCount;
            this._currentAxisSettings.stepPrevious = -1 * (this._currentAxisSettings.colCount);
        }

        //this._xData = response;
        this.setAxisData(response.xDescriptors);
        this.setWeekRecordAxisData(response.weekRecordData, true);
        this.drawCalendarWeekNavigation(response.navigationWeeks);

        this._loadDataGrid();

    }

    private _onGetXAxisDescriptorsError(error: any): void {

        console.error(error);
        this.StandbyStop();
        this._isSwitchingXActive = false;
        this.UiModder.domClass.remove(this.stickyNavigationContainer, "inactive");

        this.showError(error.Message);
        //alert(error.message);
    }

    private _loadDataGrid(): void {
        if (this._requestTimeout != null) {
            clearTimeout(this._requestTimeout);
            this._requestTimeout = null;
        }

        // aktuell eingestellte Ansicht ans Backend, neue Daten erhalten

        //console.log("request employments", this._currentXAxisDisplaySettings);

        this.StandbyStart(this.tableContainer);

        var data = {
            "itemsX": this._currentAxisSettings.xIDs,
            "itemsY": this._currentAxisSettings.yIDs
        };
        
        this.RequestManager.callfunction(
            "Webtool_API_PEP__GetDataGridJSON",
            data,
            lang.hitch(this, this._onLoadDataGridResponse),
            lang.hitch(this, this._onLoadDataGridError)
        );

        //if (true || FeatureHelpers.hasFeature("PEP/loadAdditionalCellNotes")) {
        //    this.RequestManager.callfunction("Webtool_API_PEP__GetAdditionalCellNotesData", 
        //        data,
        //        lang.hitch(this, this._onLoadAdditionalCellNotesResponse, true ),
        //        lang.hitch(this, this._onLoadAdditionalCellNotesResponse, false )
        //    );
        //}
         
    }
    private _onLoadDataGridResponse(response: PEP.DataGrid) {


        setTimeout(lang.hitch(this, "StandbyStop"), 500);
        this._isSwitchingXActive = false;
        this.UiModder.domClass.remove(this.stickyNavigationContainer, "inactive");
        this.UiModder.domClass.remove(this.xContainer, "obsolete");
        this.UiModder.domClass.remove(this.infoSpacingA, "obsolete");
        this.UiModder.domClass.remove(this.infoSpacingB, "obsolete");
        this.UiModder.domClass.remove(this.yContainerInfoA, "obsolete");
        this.UiModder.domClass.remove(this.yContainerInfoB, "obsolete");
        this.UiModder.domClass.remove(this.tableContainer, "hide");
        this.showError(false);

        console.log("_onLoadDataGridResponse", response, this.cells, this.rows);
        
        this.emptyCells(this.cells);
        this.applyDataGrid(response);

        this._requestTimeout = null;
    }

    private applyDataGrid(data: PEP.DataGrid): void {

        this.drawEmployments(data.employments);

        this.drawCellInfos(data.dayRecordInfos, data.cellNotesData); //// INFOS

        this._initialised = true;

        this.applyLocks(data.locks);
        this.recalcRowHeights();
        this.recalcColumnWidths();

        // navigieren zu Url-Target?
        let targetID = this.getUrlParameterValue(PEP.UrlParameter.targetID);
        let targetType = this.getUrlParameterValue(PEP.UrlParameter.targetType);
        if (targetID != false && targetType != false) {
            if (targetType == "employment") {
                let employment = this.getEmploymentWidgetById(targetID);
                //console.debug("url target!", targetID, employment);
                if (employment != null) {
                    employment.highlight();
                }
            }

            else if (targetType == "contract") {
                for (let row of this.rows) {
                    if (row.ID == targetID) {
                        row.node.scrollIntoView({ behavior: "smooth", block: "center" });
                        break;
                    }
                }
            }

            
        }

        this.removeUrlParameter(PEP.UrlParameter.targetID);
        this.removeUrlParameter(PEP.UrlParameter.targetType);


        this.UiModder.domClass.remove(this.table, "obsolete");
    }

    private _onLoadDataGridError(error: any): void {

        console.error(error);
        this.StandbyStop();
        this._isSwitchingXActive = false;
        this.UiModder.domClass.remove(this.stickyNavigationContainer, "inactive");
        this.showError(error.Message);
}

    //private _cellNotesDataReg: Record<string, { widgets: Array<PEPcellNotesData>, data: PEP.CellNotesData[], cell: PEP.Cell }>;
    //private _onLoadAdditionalCellNotesResponse(success: boolean, response) {

    //    this._cellNotesDataReg = {};

    //    if (success != true) {
    //        let error = response as more.requestErrorMessage;
    //    } else {
    //        let data = response as { cellNotesData: Array<PEP.CellNotesData> };
    //        this._prepareCellNotesRegistry(data.cellNotesData);
    //    }
    //}

    //private _prepareCellNotesRegistry(data: Array<PEP.CellNotesData>, bDraw?: boolean, resetPerCell?: boolean, resetAll?: boolean) {
    //    if (resetAll === true) {
    //        //this.emptyCellNotes();
    //        this._cellNotesDataReg = {};
    //    }

    //    else if (resetPerCell === true) {
    //        for (let cellNote of data) {
    //            //this.emptyCellNotes(cellNote.xID + cellNote.yID);
    //            this._cellNotesDataReg[cellNote.xID + cellNote.yID] = null;
    //        }
    //    }

    //    for (let cellNote of data) {
    //        let cell = this.getCellByXY(cellNote.xID, cellNote.yID);
    //        let regEntry = this._cellNotesDataReg[cell.xID + cell.yID];
    //        if (!regEntry) {
    //            regEntry = {
    //                data: [],
    //                cell: cell,
    //                widgets: []
    //            };
    //            this._cellNotesDataReg[cell.xID + cell.yID] = regEntry;
    //        }
    //        regEntry.data.push(cellNote);
    //    }

    //    // zeichnen, falls Rest schon fertig
    //    if (bDraw === true) {
    //        this.drawCellNotes();
    //    }

    //    // ansonsten bleibts inzwischen in der Reg und die CellInfos zeichnen die selber mit
    //}

    private getEmploymentWidgetIndexById(employmentID: string, cell?: PEP.Cell): number {
        let index = 0;

        if (typeof (cell) != "undefined" && cell != null) {
            for (let empl of cell.employmentWidgets) {
                let data: PEP.EmploymentData = empl.get("data");
                if (data.ID == employmentID) {
                    return index;
                }
                index++;
            }
            //console.warn("getEmploymentWidgetIndexById in cell: no result", employmentID);
            return -1;
        }

        for (let empl of this._employmentWidgets) {
            let data: PEP.EmploymentData = empl.get("data");
            if (data.ID == employmentID) {
                return index;
            }
            index++;
        }
        //console.warn("getEmploymentWidgetIndexById in table: no result", employmentID);
        return -1;
    }

    getEmploymentWidgetById(employmentID: string): MdsLax<InstanceType<typeof PepEmploymentWidget>> {

        //return this._employmentWidgetDict[employmentID];
        let index = this.getEmploymentWidgetIndexById(employmentID);
        if (index != -1) {
            return this._employmentWidgets[index];
        }

        console.warn("getEmploymentWidgetById: list of employmentWidgets incomplete?");

        //Plan B: in den Cells suchen

        for (let cell of this.cells) {
            for (let empl of <Array<MdsLax<InstanceType<typeof PepEmploymentWidget>>>>cell.employmentWidgets) {
                let data: PEP.EmploymentData = empl.get("data");
                if (data.ID == employmentID) {
                    return empl;
                }
            }
        }

        return null;
    }

    private emptyCells(targetCells: Array<PEP.Cell>): void {
        for (let cell of targetCells) {

            for (let data of cell.employmentData) {
                let index = this.getEmploymentWidgetIndexById(data.ID);
                if (index != -1) {
                    let widget: MdsLax<InstanceType<typeof PepEmploymentWidget>> = this._employmentWidgets[index];
                    widget.destroy();
                    this._employmentWidgets.splice(index, 1);
                }
            }
            

            cell.employmentData = [];
            cell.employmentWidgets = [];

            this.UiModder.domConstruct.empty(cell.employmentsNode);
        }
    }


    //emptyWeekRecordInfo(): void {
    //    for (let entry of this.weekRecordElementsA) {
    //        if (entry.node != null) {
    //            this.UiModder.domConstruct.destroy(entry.node);
    //            entry.node = null;
    //        }
    //    }
    //}

    destroyWeekRecordInfo(): void {

        //console.debug("destroyWeekRecordInfo");

        this.weekRecordElementsA = [];
        this.weekRecordElementsB = [];
        this.UiModder.domConstruct.empty(this.yContainerInfoA);
        this.UiModder.domConstruct.empty(this.yContainerInfoB);
    }

    private cleanUpCells(targetCells: Array<PEP.Cell>): void {


        if (typeof (targetCells) == "undefined" || targetCells == null) {
            targetCells = this.cells;
        }

        //console.debug("cleanUpCells", targetCells);


        for (let cell of targetCells) {
            //this.UiModder.domClass.remove(cell.tableCellNode, "dirty");
            this.setCellDirtyStyle(cell, -1 * cell.dirtyCount);

            // Daten ohne ID / virtuell / löschend rauswerfen
            let bLoop: boolean = true;
            let bContentChanged: boolean = false;
            while (bLoop == true) {
                bLoop = false; // I'm a robot, bleep bloop :)

                for (let i = 0; i < cell.employmentData.length; i++) {
                    if (cell.employmentData[i].ID == null || cell.employmentData[i].virtual === true) {
                        cell.employmentData.splice(i, 1);
                        bLoop = true;
                        break;
                    }
                }

                for (let i = 0; i < cell.employmentWidgets.length; i++) {

                    let widget: MdsLax<InstanceType<typeof PepEmploymentWidget>> = cell.employmentWidgets[i];
                    let data: PEP.EmploymentData = widget.get("data");

                    if (data.ID == null || widget.isDeleting == true || widget.isVirtual == true) {
                        

                        let index = this.getEmploymentWidgetIndexById(data.ID);
                        if (index != -1) {
                            this._employmentWidgets.splice(index, 1);
                        } else {
                            console.warn("cleanUpCells: no widget found in Array for ID!", data);
                        }

                        cell.employmentWidgets.splice(i, 1);

                        widget.destroy();

                        //console.debug("destroyed employment!", cell.employmentWidgets);

                        bLoop = true;
                        bContentChanged = true;
                        break;
                    }
                }       
            }

            if (cell.infoNode && bContentChanged == true) {
                this.UiModder.domConstruct.empty(cell.infoNode);
                cell.infoData = null;
            }

            if (cell.employmentWidgets.length == 0) {
                this.UiModder.domClass.add(cell.employmentsNode, "emptyCreateClick"); // wenn leer: Click im Defaultmodus wird wie Erzeugen dargestellt
            }
        }

        //console.log("cleanup cells finished", targetCells, this.cells, this._employmentWidgets);
    }

    private drawEmployments(data: Array<PEP.EmploymentData>): void {
        //console.debug("drawEmployments", data);
        //let cellList: Array<PEP.PepCell> = [];
        //let collectedCoordinates: Array<string> = [];
        if (!data) return;
        
        for (let employmentData of data) {
            
            let cell: PEP.Cell = this.getCellByXY(employmentData.xID, employmentData.yID);
            
            if (cell != null) {

                
                let employmentWidget: MdsLax<InstanceType<typeof PepEmploymentWidget>> = null;

                // zuerst schauen ob in der Cell schon ein solches Employment enthalten ist
                for (let empl of <Array<MdsLax<InstanceType<typeof PepEmploymentWidget>>>>cell.employmentWidgets) {
                    let data: PEP.EmploymentData = empl.get("data");

                    if (data.ID == employmentData.ID) {
                        employmentWidget = empl;
                        break;
                    }
                }

                // wegen Sortierung: bestehendes Employment muss raus und neu gezeichnet werden
                if (employmentWidget != null) {

                    let index = this.getEmploymentWidgetIndexById(employmentData.ID);
                    if (index != -1) {
                        this._employmentWidgets.splice(index, 1);
                    }

                    index = this.getEmploymentWidgetIndexById(employmentData.ID, cell);
                    if (index != -1) {
                        cell.employmentWidgets.splice(index, 1);
                    }

                    employmentWidget.destroy();
                    employmentWidget = null;
                }

                // prüfen ob dieser Datensatz enthalten ist und rauswerfen - wird ersetzt
                for (let i = 0; i < cell.employmentData.length; i++) {
                    if (cell.employmentData[i].ID == employmentData.ID) {
                        cell.employmentData.splice(i, 1);
                        break;
                    }
                }


                if (employmentWidget == null) {
                    employmentWidget = new PepEmploymentWidget();
                    cell.employmentWidgets.push(employmentWidget);
                    employmentWidget.set("tableCell", cell);
                    employmentWidget.on("update", lang.hitch(this, this._onUpdateEmployment, cell, employmentWidget));
                    this._employmentWidgets.push(employmentWidget);
                    this.UiModder.domConstruct.place(employmentWidget.domNode, cell.employmentsNode);
                }    

                cell.employmentData.push(employmentData);

                employmentWidget.setData(employmentData);
                employmentWidget.startup();

                this.UiModder.domClass.remove(cell.employmentsNode, "emptyCreateClick"); // kein Create-Click mehr möglich sobald was drin ist


                //console.debug("draw employment", cell, employmentData, employmentWidget.domNode);
            } else {
                console.warn("can't draw employment: no cell?!", cell, employmentData);
            }
        }
    }

    private _onUpdateEmployment(cell: PEP.Cell, employment: MdsLax<InstanceType<typeof PepEmploymentWidget>>) {
        this.reloadCoordinates({
            xID: cell.xID,
            yID: cell.yID,
            updateCellContent: true,
            updateXAxisDescriptor: true,
            updateYAxisDescriptor: false,
        }, employment.getData().ID);
    }

    private _onUpdateXelement(xCol: PEP.XCol) {
        this.reloadCoordinates({
            xID: xCol.ID,
            yID: null,
            updateCellContent: true,
            updateXAxisDescriptor: true,
            updateYAxisDescriptor: false,
        });
    }

    updateXaxisDescriptors() {
        this.reloadCoordinates({
            xID: null,
            yID: null,
            updateXAxisDescriptor: true,
            updateCellContent: false,
            updateYAxisDescriptor: false
        });
    }
    private reloadCoordinates(requestdata: partialUpdatesRequest, previouslyOpenedEmploymentID?: string) {

        // nur zulassen wenn nichts in Speicher-Warteschlange!
        if (this.submitQueue?.length > 0) return;

        // erweitern!
        let _requestData = { ...requestdata } as any;
        _requestData.itemsY = this._currentAxisSettings.yIDs;
        _requestData.displaySettings = this.windowEx.DisplaySettings;
       
        this.RequestManager.callfunction(
            "Webtool_API_PEP__PartialAxisUpdate",
            _requestData,
            lang.hitch(this, this._onReloadCoordinatesResponse, requestdata, true, previouslyOpenedEmploymentID),
            lang.hitch(this, this._onReloadCoordinatesResponse, requestdata, false, previouslyOpenedEmploymentID),
        );
    }

    private _onReloadCoordinatesResponse(requestData: partialUpdatesRequest, success: boolean, previouslyOpenedEmploymentID: string, response) {
        if (success != true) {
            let error = response as more.requestErrorMessage;
        } else {
            let data = response as PEP.Coordinates & Partial<PEP.SaveEmploymentsResponse>;

            if (requestData.xID && !requestData.yID && requestData.updateCellContent == true) {
                // es wurde ein Update für die ganze Achse (vertikal, nur x-ID bekannt) angefragt
                // falls Zellen neu gezeichnet werden, müssen dayrecords und cellnotes ausgeleert werden
                let col = this.getXcolById(requestData.xID);
                if (col && col.cells) {
                    for (let cell of col.cells) {
                        domConstruct.empty(cell.infoNode);
                    }
                }
            }
            this.redrawCellContents(data.employments, data.dayRecordInfos, data.cellNotesData);
            
            this.updateXDescriptors(data.xDescriptorUpdates);
            //this.updateYDescriptors(data.yDescriptorUpdates); // TODO

            if (previouslyOpenedEmploymentID) {
                let newEmplWidget = this.getEmploymentWidgetById(previouslyOpenedEmploymentID);
                if (newEmplWidget) newEmplWidget.showEditor("previous");
            }

            this.recalcRowHeights();

        }
    }

    private drawCellInfos(infos: Array<PEP.DayRecordInfo>, cellNotes: PEP.CellNotesData[]): void {
        //console.debug("drawInfos", data, this.windowEx.DisplaySettings);
        // cellnotes und dayrecordInfos zusammenführen
        let cellInfos: Record<string, PEP.CellInfoData> = {};

        if (!cellNotes) cellNotes = [];
        

        for (let dayRecord of infos) {
            let xy = dayRecord.xID + dayRecord.yID;
            let cellInfo = cellInfos[xy];
            if (!cellInfo) {
                cellInfo = {
                    xID: dayRecord.xID,
                    yID: dayRecord.yID,
                    dayRecordInfo: null,
                    cellNotes: []
                };
                cellInfos[xy] = cellInfo;
            }
            cellInfo.dayRecordInfo = dayRecord; // Anm: sollte sich niemals überschreiben - pro xy nur eine dayRecordInfo
        };

        for (let cellNote of cellNotes) {
            let xy = cellNote.xID + cellNote.yID;
            let cellInfo = cellInfos[xy];
            if (!cellInfo) {
                cellInfo = {
                    xID: cellNote.xID,
                    yID: cellNote.yID,
                    dayRecordInfo: null,
                    cellNotes: []
                };
                cellInfos[xy] = cellInfo;
            }

            cellInfo.cellNotes.push(cellNote);
        }

        for (let key in cellInfos) {

            let infoData = cellInfos[key];
            let cell: PEP.Cell = this.getCellByXY(infoData.xID, infoData.yID);

            if (cell != null) {
                if (cell.infoNode != null) {
                    this.UiModder.domConstruct.empty(cell.infoNode);
                }


                if (infoData.cellNotes) {
                    for (let data of infoData.cellNotes) {
                        let cellWidget = new PEPcellNotesData();

                        cellWidget.setData(data, false);
                        cellWidget.placeAt(cell.infoNode);
                    }
                }

                cell.infoData = infoData;

                if (true) { // immer erzeugen, wird via css ausgeblendet... //(this.windowEx.DisplaySettings.displayDayRecordSums == true) {

                    let notesContainer = this.UiModder.domConstruct.create("div",
                        {
                            "className": "PEP_dayRecordInfo notes w3-block w3-hide"
                        },
                        cell.infoNode, "last");

                    // Anmerkungen des Tages
                    let dayRecord = infoData.dayRecordInfo;
                    if (dayRecord) {
                        if (dayRecord.notes) {
                            for (let note of dayRecord.notes) {
                                this.UiModder.domConstruct.create("pre",
                                    { "innerHTML": note, "className": "dayRecordNote" }
                                    , notesContainer);
                            }

                            this.hideNode(notesContainer, dayRecord.notes.length <= 0);
                        }

                        // interne Anmerkung
                        if (dayRecord.note_internal_use) {
                            this.UiModder.domConstruct.create("pre",
                                {
                                    "innerHTML": dayRecord.note_internal_use,
                                    "className": "dayRecordNote internal"
                                },
                                notesContainer);

                            this.hideNode(notesContainer, false);
                        }

                        // Tagesdatensatz (4-spaltige Wertezeile)
                        if (dayRecord.columns) {
                            let dayRecordHTML = "";

                            for (let col of dayRecord.columns) {
                                dayRecordHTML += this.stringFormat(_tmplDayInfo,
                                    col.label,
                                    col.value,
                                    col.colorationBG != "" ? col.colorationBG : "none",
                                    col.colorationTXT != "" ? col.colorationTXT : "none",
                                    col.tooltip,
                                    col.grow
                                );
                            }

                            let dayRecordContainer = this.UiModder.domConstruct.create("div",
                                { "innerHTML": dayRecordHTML, "className": "PEP_dayRecordInfo w3-block flex_row_center" }, cell.infoNode);
                            cell.dayRecordNode = dayRecordContainer;
                        }
                    }
                }
                
            } else {
                console.warn("can't draw info: no cell?!", cell, infoData);
            }
        }

        
    }

    private editInternalNote(cell: PEP.Cell) {

    }

    recalcColumnWidths(): void {

        let widthA = this.yContainerInfoA.getBoundingClientRect().width;//marginBox.h;
        let widthB = this.yContainerInfoB.getBoundingClientRect().width;//marginBox.h;
        this.UiModder.domStyle.set(this.infoSpacingA, "width", widthA.toFixed(2) + "px");
        this.UiModder.domStyle.set(this.infoSpacingB, "width", widthB.toFixed(2) + "px");
        
    }

    recalcRowHeights(targetRow?: PEP.YRow): void {
        //console.log("recalcRowHeights", this._initialised, this.rows, this.weekRecordElementsA);

        let rows = this.rows;

        if (targetRow != null && typeof (targetRow) != "undefined") {
            rows = [targetRow];
        }

        for (let row of rows) {
           
            this.UiModder.domStyle.set(row.node, "height", "");
            this.UiModder.domStyle.set(row.headerNode, "height", "");

            let rowHeight = row.node.getBoundingClientRect().height;//marginBox.h;

            let maxHeight = rowHeight;
            let maxHeightTxt = maxHeight.toFixed(2) + "px";
            row.node.style.setProperty("--rowHeight", maxHeightTxt);

            //console.log("recalcRowHeights", row, rowHeight, maxHeight);

            let rowInfoA = null;
            let rowInfoB = null;

            if (this._initialised === true) {
                //for (let weekRec of this.weekRecordElementsA) {
                //    if (row.ID == weekRec.data.yID) {
                //        rowInfoA = weekRec;
                //        this.UiModder.domStyle.set(rowInfoA.node, "height", "");
                //        let height = weekRec.node.getBoundingClientRect().height;
                //        if (height > maxHeight) maxHeight = height;
                //        break;
                //    }

                //}

                for (let weekRec of this.weekRecordElementsB) {
                    if (row.ID == weekRec.data.yID) {
                        rowInfoB = weekRec;
                        this.UiModder.domStyle.set(rowInfoB.node, "height", "");
                        let height = weekRec.node.getBoundingClientRect().height;
                        if (height > maxHeight) maxHeight = height;
                        break;
                    }
                }

                if (rowHeight != maxHeight) {
                    this.UiModder.domStyle.set(row.node, "height", maxHeightTxt);
                }

                if (rowInfoA) {
                    this.UiModder.domStyle.set(rowInfoA.node, "height", maxHeight.toFixed(2) + "px");
                }

                if (rowInfoB) {
                    this.UiModder.domStyle.set(rowInfoB.node, "height", maxHeight.toFixed(2) + "px");
                }

                if (row.headerNode) {
                    this.UiModder.domStyle.set(row.headerNode, "height", maxHeight.toFixed(2) + "px");
                }

            }
        }
    }

    private applyLocks(locks: Array<PEP.CellLock>): void {
        for (let cell of this.cells) {
            let isLocked: boolean = undefined;
            for (let lock of locks) {
                if (lock.xID == cell.xID && lock.yID == cell.yID) {
                    isLocked = lock.locked;
                    break;
                }
            }
            if (isLocked != undefined) {
                cell.locked = isLocked;
            }
            if (cell.locked === true) {
                this.UiModder.domClass.remove(cell.employmentsNode, "editable");
                this.UiModder.domClass.add(cell.employmentsNode, "locked");
                
                if (cell.clickEvent != null) {
                    removeEventListener("click", cell.clickEvent); //?!
                    cell.clickEvent = null;
                }
            } else {
                if (cell.clickEvent == null) {
                    //let newButton = this.UiModder.domConstruct.create("div", { "innerHTML": _tmplNewButton, "className": "PEP_employment new" }, cell.node, "last");
                    //on(newButton, "click", lang.hitch(this, this._onClickNewEmployment, cell));
                    //cell.newButtonNode = newButton;
                    this.UiModder.domClass.add(cell.employmentsNode, "editable");
                    this.UiModder.domClass.remove(cell.employmentsNode, "locked");
                    cell.clickEvent = on(cell.employmentsNode, "click", lang.hitch(this, this._onClickEmploymentsContainer, cell));        
                }
            }
            
        }

        // die y-Achse "inaktiv" markieren wenn es nur gesperrte Einträge gibt
        for (let row of this.rows) {
            let yDiv = row.headerNode;

            let bInactive = true;
            for (let cell of row.cells) {
                if (!cell.locked) {
                    bInactive = false;
                    break;
                }
            }

            //console.debug("row inactive?", bInactive, row);

            row.inactive = bInactive;

            if (bInactive) {
                this.UiModder.domClass.add(yDiv, "inactive");
            } else {
                this.UiModder.domClass.remove(yDiv, "inactive");
            }
        }
    }

    private getCellByXY(x: string, y: string): PEP.Cell {

        //console.debug("getCellByXY", x, y);
        return this.cellDict[x + y];
        //for (let row of this.rows) {
        //    if (row.ID == y) {
        //        for (let cell of row.cells) {
        //            if (cell.xID == x) {
        //                return cell;
        //                //break;
        //            }
        //        }
        //        break;
        //    }

            
        //}
        return null;
    }

    //private getCellByID(cellID: string) {

    //}
    private getXcolById(xID: string): PEP.XCol {
        for (let xAxis of this.columns) {
            if (xAxis.ID == xID) {
                return xAxis;
                break;
            }
        }

        return null;
    }
    private getXcolByCell(cell: PEP.Cell): PEP.XCol {
        if (cell == null) return null;

        return this.getXcolById(cell.xID);
    }

    private getYrowByCell(cell: PEP.Cell): PEP.YRow {
        if (cell == null) return null;

        for (let yAxis of this.rows) {
            if (yAxis.ID == cell.yID) {
                return yAxis;
                break;
            }
        }

        return null;

    }

    private setCellDirtyStyle(cell: PEP.Cell, increaseDirtyStep?: number) {
        if (cell == null) {
            return;
        }

        if (typeof (increaseDirtyStep) != "undefined" && increaseDirtyStep != null) {
            cell.dirtyCount = cell.dirtyCount + increaseDirtyStep;
        }

        //console.debug("setCellDirtyStyle", cell.dirtyCount, cell.node);

        let fct = this.UiModder.domClass.remove;

        if (cell.dirtyCount > 0) {
            fct = this.UiModder.domClass.add;
        }

        fct(cell.employmentsNode, "dirty");
    }

    removeFromSubmitQueue(employmentWidget: MdsLax<InstanceType<typeof PepEmploymentWidget>>) {
        let index = 0;
        //console.debug("removeFromSubmitQueue", employmentWidget.tableCell.node, employmentWidget.submitData, employmentWidget._getDataAttr() );
        if (!employmentWidget.submitData) {
            console.warn("removeFromSubmitQueue: widget with empty submitdata!", employmentWidget.tableCell.node, employmentWidget.getData());
        }
        else {
            let targetID = employmentWidget.submitData.editedData.ID;
            for (let entry of this.submitQueue) {

                if (entry.submitData.editedData.ID == targetID) {
                    this.submitQueue.splice(index, 1);

                    this.UiModder.domClass.remove(entry.domNode, "dirty changing deleting creating created");
                    
                    let cell = employmentWidget.tableCell;
                    this.setCellDirtyStyle(cell, -1);

                    if (employmentWidget.submitData.mode == PEP.SubmitEntryMode.create) {
                        let index = this.getEmploymentWidgetIndexById(targetID);
                        if (index != -1) {
                            this._employmentWidgets.splice(index, 1);
                            //console.debug("removeFromSubmitQueue - success array table!", targetID, index, this._employmentWidgets);
                        }
                        else {
                            console.warn("removeFromSubmitQueue: could not remove from array of widgets in table!", employmentWidget.submitData);
                        }

                        index = this.getEmploymentWidgetIndexById(targetID, cell);
                        if (index != -1) {
                            cell.employmentWidgets.splice(index, 1);
                            //console.debug("removeFromSubmitQueue - success array cell!", targetID, index, cell.employmentWidgets);
                        }
                        else {
                            console.warn("removeFromSubmitQueue: could not remove from array of widgets in cell!", employmentWidget.submitData);
                        }

                        employmentWidget.destroy();
                        
                    }

                    if (cell.employmentWidgets.length == 0) {
                        this.UiModder.domClass.add(cell.employmentsNode, "emptyCreateClick");
                    }
                    //console.debug("removeFromSubmitQueue", targetID, cell.node, cell.employmentWidgets, this._employmentWidgets);
                    break;
                }

                index++;
            }
        }
        
        this.displaySubmitQueue();
    }
    addToSubmitQueue(employmentWidget: MdsLax<InstanceType<typeof PepEmployment>>) {
        if (this._submitQueueTimeout != null) {
            clearTimeout(this._submitQueueTimeout);
            this._submitQueueTimeout = null;
        }

        // bestätigtes NEU ERZEUGTES Widget in die Familie aufnehmen:
        if (employmentWidget.submitData.mode == PEP.SubmitEntryMode.create) {
            if (this.getEmploymentWidgetIndexById(employmentWidget.submitData.editedData.ID) == -1) {
                this._employmentWidgets.push(employmentWidget);
                employmentWidget.tableCell.employmentWidgets.push(employmentWidget);
            }
        }

        let submitEntry = employmentWidget;

        let index: number = 0;
        let lengthDifference: number = this.submitQueue.length;
        // prüfen ob der Datensatz nicht eh schon in der Liste ist
        for (let entry of this.submitQueue) {

            if (entry.submitData.editedData.ID == submitEntry.submitData.editedData.ID) {
                this.submitQueue.splice(index, 1);
                break;
            }
            
            index++;
        }

        this.submitQueue.push(submitEntry);

        lengthDifference = this.submitQueue.length - lengthDifference;

        let cell = null;
        if (employmentWidget != null) {
            cell = employmentWidget.tableCell;
        } else {
            cell = this.getCellByXY(submitEntry.submitData.editedData.xID, submitEntry.submitData.editedData.yID);
        }
        
        this.setCellDirtyStyle(cell, lengthDifference);


        //// Toast: neue Änderung eingegangen - lieber nicht, ist LÄSTIG wenn man 10 Sachen hintereinander anklickt
        //let message = this.translations["PEP_summary_pendingChanges"];
        //message = "änderung...";
        //this.PepHome.showToast(message, employmentWidget.submitData.editedData.ID, 3000, toasterIcons.confirmCheck, null, null);


        this.displaySubmitQueue();
    }

    private displaySubmitQueue(): void {

        //console.log("new submit queue", this.submitQueue, this._employmentWidgets.length, this.cells);

        this.recalcRowHeights();

        if (this.submitQueue.length == 0) {
            this.PepHome.removeToast("pendingChanges");
            window.onbeforeunload = null;
            this.isDirty = false;
            return;
        }

        this.isDirty = true;

        window.onbeforeunload = function () {
            return ""; // diese Meldung wird eh nirgends angezeigt... der browser bringt die standardmeldung die man nicht beinflussen kann
        };

        // Zusammenfassung als Toast:
        let message = TranslationHelpers.translate("PEP_summary_pendingChanges");
        message = this.stringFormat(message, this.submitQueue.length.toString())
        this.showToast({
            title: message,
            options: {
                ID: "pendingChanges",
                timeout: "permanent",
                buttons: [{
                    icon: ToasterHelpers.ToasterIcons.confirmCheck,
                    label: "",
                    callback: lang.hitch(this, this.saveData)
                }, {
                    icon: ToasterHelpers.ToasterIcons.undo,
                    label: "",
                    callback: lang.hitch(this, this.rollback)
                }
                ],
                closeButton: false
            }
        });

        //this.saveDataDelayed();
    }

    private rollback(): void {

        let editor: MdsLax<InstanceType<typeof PepEmploymentEditor>> = this.windowEx.PepEmploymentEditor;

        if (editor?.isActive) {
            editor.closeAndSubmit();
        }

        // alles was geändert (nicht neu) worden ist oder Löschmarkierung hat gehört jetzt wiederhergestellt
        let functionArray: Array<any> = [];
        for (let entry of this.submitQueue) {
            functionArray.push(lang.hitch(entry, "confirmNewData", entry.submitData, true));
            //entry.confirmNewData(entry.submitData, true);
        }

        for (let fct of functionArray) {
            fct();
            // => alle geänderten/neuen Einträge werden jetzt einzeln (nicht) "confirmed"
            // => kette geht weiter bei removefromsubmitqueue
        }

        this.PepHome.removeToast("saveError");

        this.emptyQueue(); // leert die Liste und entfernt mal alles was Löschmarkierung hat oder virtuell is       

    }

    private emptyQueue(): void {


        let cellsToReload: Array <PEP.Cell> =[];
        for (let entry of this.submitQueue) {
            let cell = entry.tableCell;
            if (cell != null) {
                this.UiModder.domClass.remove(cell.employmentsNode, "dirty creating");
                cellsToReload.push(cell);
            } else {
                console.warn("emptyQueue: employment-entry (widget) does not have a cell!", entry);
            }
        }

        console.debug("emptyQueue", cellsToReload, this.submitQueue);

        this.submitQueue = [];
        this._submitQueueTimeout = null;

        this.cleanUpCells(cellsToReload);

        this.displaySubmitQueue();
    }

    private saveDataDelayed(): void {
        this._submitQueueTimeout = setTimeout(lang.hitch(this, this.saveData), 800);
    }

    private abortSaveData(): void {
        if (this._submitQueueTimeout != null) {
            clearTimeout(this._submitQueueTimeout);
            this._submitQueueTimeout = null;
        }
    }

    private saveData(): void {
        this._submitQueueTimeout = null;
        if (this.submitQueue.length == 0) {
            return;
        }

        let editor: MdsLax<InstanceType<typeof PepEmploymentEditor>> = this.windowEx.PepEmploymentEditor;

        if (editor?.isActive) {
            editor.closeAndSubmit();
        }

        this.StandbyStart(this.tableContainer);

        let message = "PEPhome_savingChanges";

        this.PepHome.removeToast("saveError");

        this.showToast({
            title: message,
            options: {
                ID: "savingChanges",
                timeout: "permanent"
            },
            iconClass: ToasterHelpers.ToasterIcons.hourglass
        });

        
        let data = {
                "offset": this._currentAxisSettings.offset,
                "stepCount": this._currentAxisSettings.colCount,
            "base": this._currentAxisSettings.base,
            "contractIDs": this._currentAxisSettings.yIDs,
                "submitData": []
        };
        for (let entry of this.submitQueue) {
            data.submitData.push(entry.submitData);
        }

        //let url = this.windowEx.appRoot + "Pep/SaveEmployments";

        //let stringData = JSON.stringify(data);

        //this.RequestManager.post(
        //    url,
        //    {
        //        jsonData: stringData,
        //    },
        //    lang.hitch(this, this._onSaveDataResponse),
        //    lang.hitch(this, this._onSaveDataError),
        //    false // sync
        //);
        this.RequestManager.callfunction(
            "Webtool_API_PEP__SaveEmployments",
            data,
            lang.hitch(this, this._onSaveDataResponse),
            lang.hitch(this, this._onSaveDataError)
        );


    }

    private _onSaveDataResponse(response: PEP.SaveEmploymentsResponse): void {
        console.log("_onSaveDataResponse", response);
        this.StandbyStop();
        //let message = this.translations["PEPhome_savingChanges"];

        if (response.errorMessage) {
            this.showError(response.errorMessage);

            this.showToast({
                title: "PEP_Dlg_SavingError_Short",
                timeout: "permanent",
                showClose: true,
                iconClass: ToasterHelpers.ToasterIcons.error,
                message: response.errorMessage
            });

        }

        if (response.warnings?.length) {
            ToasterHelpers.showToast({
                title: "PEP_Dlg_SavingWarnings_Short",
                iconClass: toasterIcons.warning,
                showClose: true,
                message: TranslationHelpers.translate( "PEP_Dlg_SavingWarnings_PreMessage") + "<br><ul><li>" + response.warnings.join("</li><li>") + "</li></ul>",
                messageIcon: toasterIcons.warning,
                timeout: "permanent"
            });
        }

        this.redrawCellContents(response.employments, response.dayRecordInfos, response.cellNotesData);

        this.setWeekRecordAxisData(response.weekRecordData);

        this.updateXDescriptors(response.xDescriptorUpdates);


        this.PepHome.showToast({
            title: "PEPhome_savingChanges_done",
            ID: "savingChanges",
            iconClass: ToasterHelpers.ToasterIcons.hourglassEnd
        });

        this.StandbyStop();
    }

    private redrawCellContents(employments: Array<PEP.EmploymentData>, dayRecordInfos: Array<PEP.DayRecordInfo>, cellNotes: PEP.CellNotesData[]) {

        this.emptyQueue();

        //if (typeof (employments) == "undefined") {
        //    employments = this._lastResponse.employments;
        //}

        //if (typeof (cellInfoData) == "undefined") {
        //    cellInfoData = this._lastResponse.cellInfoData;
        //}

        // response ist ein Objekt mit Arrays der erzeugten/gelöschten/geänderten Einträge
        
        this.drawEmployments(employments);

        this.drawCellInfos(dayRecordInfos, cellNotes);


        this.recalcRowHeights();

    }

    private _onSaveDataError(error: any): void {
        console.error("_onSaveDataError", error);
        this.StandbyStop();
        //alert(error.Message);
        //this.PepHome.showError("Fehler beim Speichern!")
        this.PepHome.removeToast("savingChanges");
        this.showToast({
            title: "PEP_Dlg_SavingError_Short",
            options: {
                ID: "saveError",
                timeout: "permanent"
            },
            iconClass: ToasterHelpers.ToasterIcons.error,
            message: error.Message
        });

        this.displaySubmitQueue();
    }

    private _onClick_Contract(entity: PEP.YRowContract, evt: MouseEvent) {
        if (!FeatureHelpers.hasFeature("PEP/ClickableContract")) return;
        if (!entity) return;
        evt.stopPropagation();

        EntityHelpers.openEntityView({
            entityClass: entity.Classname,
            entityId: entity.ID,
            label: entity.label,
            contextName: "PEPtable",
            nonInteractive: true
        });
    }
    
    private _onClick_CellInfoContainer(cell: PEP.Cell, evt: MouseEvent) {

        if (this.windowEx.PepEmploymentEditor) {
            let editor = this.windowEx.PepEmploymentEditor as MdsLax<InstanceType<typeof PepEmploymentEditor>>;
            if (editor?.isActive) {
                editor.closeAndSubmit();
            }

        }
        if (this.windowEx.InfoContainerPopup) {

            if (this.windowEx.InfoContainerPopup.cell.tableCellNode == cell.tableCellNode) {
                this.closeDayRecordInfoContainer();
                return;
            }

            this.closeDayRecordInfoContainer();
        }

        //if (this.windowEx.CurrentSelectedClickMode != PEP.ClickMode.default) {
        //    return;
        //}

        evt.stopPropagation();
        evt.preventDefault();

        let infoContainer = this.UiModder.domConstruct.create("div", {
            className: "PEP_cellInfoPopupContainer",
        }, cell.infoNode);

        let xData = this.getXcolByCell(cell);
        let yData = this.getYrowByCell(cell);

        let data: Partial<PEP.CellInfoData> = cell.infoData;

        let infoForm = new PepCellInfoForm();
        infoForm.placeAt(infoContainer);
        infoForm.setData(data as PEP.CellInfoData, xData, yData);

        if (cell.locked === true && !FeatureHelpers.hasFeature("PEP/AllowCellInfoEditInLockedCells")) {
            infoForm.setReadonly(true);
        }

        infoForm.on("update", lang.hitch(this, this._onUpdateDayRecordInfoContainer, cell));
        infoForm.on("close", lang.hitch(this, this.closeDayRecordInfoContainer));
        infoForm.on("saved", lang.hitch(this, this._onSaveDayRecordInfos, cell));
        
        this.UiModder.domClass.add(cell.infoNode, "selected");

        this.UiModder.domClass.add(cell.employmentsNode, "editing");
        this.UiModder.domClass.add(cell.column.headerNode.domNode, "editing");
        this.UiModder.domClass.add(cell.row.headerNode, "editing");
        this.UiModder.domClass.add(cell.row.node, "editing");


        this.windowEx.InfoContainerPopup = {
            cell: cell,
            node: infoContainer
        };
    }

    private _onUpdateDayRecordInfoContainer(cell: PEP.Cell) {
        this.reloadCoordinates({
            xID: cell.xID,
            yID: cell.yID,
            updateCellContent: true,
            updateXAxisDescriptor: true,
            updateYAxisDescriptor: true
        });
    }
    private _onSaveDayRecordInfos(cell: PEP.Cell, newData: PEP.DayRecordInfo) {
        

        this.UiModder.domClass.remove(cell.infoNode, "selected");

        this.drawCellInfos([newData], cell.infoData?.cellNotes); // neu zeichnen
        this.recalcRowHeights(cell.row);
    }

    private _onClickEmploymentsContainer(cell: PEP.Cell, evt: MouseEvent): void {
        // ist ein Editor schon geöffnet?
        let editor = <MdsLax<InstanceType<typeof PepEmploymentEditor>>>this.windowEx.PepEmploymentEditor;
        if (editor?.isActive) {
            editor.closeAndSubmit();
        }

        this.closeDayRecordInfoContainer();

        if (this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.default ||
            this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.brush ) {
            // standardcursor + template gewählt: prüfen ob in der Zelle was drin ist!
            //console.debug("_onClickCell default emptycreate", cell.node, cell.employmentWidgets);
            if (cell.employmentWidgets.length == 0) {
                // nix drin, dann darf man hier weitermachen wie mit einem Create-Click!
                evt.stopPropagation();
            } else {
                
                return;
            }
        }
        else {
            if (this.windowEx.CurrentSelectedClickMode != PEP.ClickMode.create &&
                this.windowEx.CurrentSelectedClickMode != PEP.ClickMode.brushCreate) {
                return;
            }
        }
        

        //console.debug("_onClickCell", evt, cell);
        if (cell.locked == true) {
            return;
        }

        if (this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.create ||
            this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.brush ) {
            evt.stopPropagation();
        }

        this.addNewEmployment(cell);
    }

    private _onClickNewEmployment(cell: PEP.Cell, evt: MouseEvent) {
        evt.stopPropagation();
        //this.windowEx.PepEmploymentEditor.close();


        //console.debug("_onClickNewEmployment", cell);

        this.addNewEmployment(cell);

    }

    addNewEmployment(cell: PEP.Cell) {

        if (this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.delete) {
            return;
        }

        if (this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.brush ||
            this.windowEx.CurrentSelectedClickMode == PEP.ClickMode.brushCreate) {
            if (this.windowEx.CurrentSelectedEmploymentTypeTemplate == null) {
                this.showToast({
                    title: TranslationHelpers.translate("PEP_Dlg_BrushMode_NoTemplateSelected_Short"),
                    options: {
                        ID: "brushMode_noTemplateSelected",
                        //timeout: "permanent"
                    },
                    iconClass: ToasterHelpers.ToasterIcons.warning,
                    message: TranslationHelpers.translate("PEP_Dlg_BrushMode_NoTemplateSelected")
                });

                return;
            }
        }

        this.abortSaveData();

        let yRow = this.getYrowByCell(cell);

        // die Zelle erhält während der Erstellung (also während das Editorfenster offen ist) ein Flag
        // wir brauchen dieses Flag NICHT wenn man im Pinselplus ohne Editor was hinzufügt
        // oder wenn man den Pinsel hat und in eine leere Zelle klickt (verhält sich dann wie brushcreate)
        if (this.windowEx.CurrentSelectedClickMode != PEP.ClickMode.brushCreate &&
            (this.windowEx.CurrentSelectedClickMode != PEP.ClickMode.brush && cell.employmentWidgets.length == 0 )) {
            this.UiModder.domClass.add(cell.employmentsNode, "creating");
        }

        let employmentWidget: MdsLax<InstanceType<typeof PepEmploymentWidget>> = new PepEmploymentWidget();
        this.UiModder.domConstruct.place(employmentWidget.domNode, cell.employmentsNode);
        employmentWidget.set("tableCell", cell);
        employmentWidget.isDraft = true;
        
        employmentWidget.causedBy = "user";
        employmentWidget.applyTemplate();

        this.recalcRowHeights(yRow);
        
        //employmentDraft.showEditor();
    }

    
    _onClick_CalendarWeekNavigation(evt: MouseEvent) {
        evt.stopPropagation();
        this.toggleCalendarWeekNavigation();
    }
    _onClick_CalendarWeek(stepValue: number, newBase: any, evt: MouseEvent) {
        //this.closeCalendarWeekNavigation(); // wird durch propagation eh erreicht

        this.setNewStart(stepValue, true, newBase, true);
    }

    _onClick_PreviousStepX(evt: MouseEvent) {
        let newStart: number = this._currentAxisSettings.stepPrevious ;

        this.setNewStart(newStart, true);
    }

    _onClick_PreviousX(evt: MouseEvent) {
        let newStart: number = this._currentAxisSettings.offset - 1;

        this.setNewStart(newStart, true);
    }

    _onClick_NextX(evt: MouseEvent) {
        let newStart: number = this._currentAxisSettings.offset + 1;

        this.setNewStart(newStart, true);
    }

    _onClick_NextStepX(evt: MouseEvent) {
        let newStart: number = this._currentAxisSettings.stepNext;

        this.setNewStart(newStart, true);
    }

    _onClick_Refresh(evt: MouseEvent) {
        let newStart: number = this._currentAxisSettings.offset;

        this.setNewStart(newStart, true);
    }

    closeDayRecordInfoContainer() {
        if (this.windowEx.InfoContainerPopup) {

            let cell = this.windowEx.InfoContainerPopup.cell;

            this.UiModder.domClass.remove(cell.employmentsNode, "editing");
            this.UiModder.domClass.remove(cell.column.headerNode.domNode, "editing");
            this.UiModder.domClass.remove(cell.row.headerNode, "editing");
            this.UiModder.domClass.remove(cell.row.node, "editing");


            this.UiModder.domClass.remove(this.windowEx.InfoContainerPopup.cell.infoNode, "selected");
            this.UiModder.domConstruct.destroy(this.windowEx.InfoContainerPopup.node);
            this.windowEx.InfoContainerPopup = null;
        }

    }

    private _onClick_Global(evt: MouseEvent) {
        //console.log("click global", evt);
        if (this.windowEx.PepEmploymentEditor) {
            this.windowEx.PepEmploymentEditor.closeAndSubmit();
        }

        //this.closeDayRecordInfoContainer();
       
        this.closeCalendarWeekNavigation();
    }

    private setNewStart(newOffset: number, bReloadX: boolean, newBase?: any, bSkipDelay?: boolean) {
        //console.debug("setNewStart", bReloadX, newOffset, newBase, this._currentXAxisDisplaySettings);


        if (this.submitQueue.length > 0) {
            if (confirm(this.translations["PEP_warning_pendingChanges"]) != true) {
                return;
            }
        }

        if (this._isSwitchingXActive == true) {
            return;
        }

        this.UiModder.domClass.add(this.xContainer, "obsolete");
        this.UiModder.domClass.add(this.yContainerInfoA, "obsolete");
        this.UiModder.domClass.add(this.yContainerInfoB, "obsolete");
        this.UiModder.domClass.add(this.infoSpacingA, "obsolete");
        this.UiModder.domClass.add(this.infoSpacingB, "obsolete");
        this.UiModder.domClass.add(this.table, "obsolete");

        this.rollback();

        //if (newStart == this._currentXAxisDisplaySettings.startStep) {
        //    return;
        //}

        //console.debug("setnewdate", newDate);

        this._currentAxisSettings.offset = newOffset;

        if (newBase != null && typeof (newBase) != "undefined") {
            this._currentAxisSettings.stepNext = newOffset + this._currentAxisSettings.colCount;
            this._currentAxisSettings.stepPrevious = newOffset - this._currentAxisSettings.colCount;
            this._currentAxisSettings.base = newBase;
        }

        // ist das Startdatum innerhalb der "Step"-Grenzen?
        while (newOffset <= this._currentAxisSettings.stepPrevious) {
            this._currentAxisSettings.stepPrevious = this._currentAxisSettings.stepPrevious - this._currentAxisSettings.colCount; // die großen Datumsschritte zurücksetzen
            this._currentAxisSettings.stepNext = this._currentAxisSettings.stepNext - this._currentAxisSettings.colCount; // die großen Datumsschritte zurücksetzen
        }

        while (newOffset >= this._currentAxisSettings.stepNext) {

            this._currentAxisSettings.stepPrevious = this._currentAxisSettings.stepPrevious + this._currentAxisSettings.colCount; // die großen Datumsschritte erhöhen
            this._currentAxisSettings.stepNext = this._currentAxisSettings.stepNext + this._currentAxisSettings.colCount;
        }

        if (bSkipDelay == true) {
            this.loadData(bReloadX);
        } else {
            this.loadDataDelayed(bReloadX);
        }
    }


    postMixInProperties(args?: any): void {
        super.postMixInProperties.apply(this, arguments as any);

        this.windowEx = window as any;
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this._xDescriptors = [];
        this._yDescriptors = [];
        this.rows = [];
        this._employmentWidgets = [];
        this.submitQueue = [];

        //this._table = this.UiModder.domConstruct.create("table");
        this.PepHome = this.windowEx.PepHome;
    }

    destroy(): void {

        this.rollback();
        (this.destroyDescendants as any)();
        super.destroy.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        topic.subscribe("PEPclick_global", lang.hitch(this, this._onClick_Global));
        topic.subscribe("PEP/EmploymentChanged", lang.hitch(this, this.recalcRowHeights));
    }
}

export default mdsWidget(PepRosterTable);